<script>
  import { previews_scrolled_up } from '../stores'
  import Button from "../elements/Button.svelte"
  
  function backToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
</script>

<div class="scrollToTopButton" class:visible={$previews_scrolled_up}>
  <Button kind="default" circle={true} on:click={backToTop}><svg><use class="svg-icon" xlink:href="#icon-back-to-top"/></svg></Button>
</div>

<style>
  div {
    position: fixed;
    z-index: 3;
    top: -6rem;
    left: 50%;
    margin-left: -2rem;
    transition: top var(--transition-props);
  }
  div.visible {
    top: 8rem;
  }
  svg {
    float: left;
    width: 3.6rem;
    height: 3.6rem;
    fill: var(--c-text-on-fill);
    stroke: var(--c-text-on-fill);
  }
</style>